import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "tab";
var attributes = {
    DISABLED: 'disabled',
    ACTIVE: 'active',
    STRETCH: 'stretch',
    FOCUS_ON_ACTIVATE: 'focus-on-activate'
};
var selectors = {
    BUTTON: 'button.tyl-tab',
    RIPPLE: '.tyl-tab__ripple',
    INDICATOR: '.mdc-tab-indicator',
    CONTENT: '.tyl-tab__content',
    DEFAULT_SLOT: 'slot:not([name])'
};
var classes = {
    ACTIVE: 'tyl-tab--active'
};
var events = {
    INTERACTED: elementName + "-interacted"
};
export var TAB_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    selectors: selectors,
    classes: classes,
    events: events
};
